// extracted by mini-css-extract-plugin
export default {"slick-loading":"cwbtb","slider":"lGi2g"};